import { createSelector } from 'reselect';
import { createErrorDataSelector } from 'selectors/selectorUtils';
import { apiCallStatus } from 'helpers/constants';
import { dateKind } from '../../../constants';


const getSelectedEvent = ({ eventLog }) => {
	return eventLog.selectedEvent;
};

const getEventLogs = ({ eventLog }) => {
	return eventLog.eventLogs;
};

const getPostCommentStatus = ({ selfFaultEvaluation }) => {
	return selfFaultEvaluation.postComment.loadingStatus;
};

const getGetCommentsStatus = ({ selfFaultEvaluation }) => {
	return selfFaultEvaluation.comments.loadingStatus;
};

const getDeleteCommentStatus = ({ selfFaultEvaluation }) => {
	return selfFaultEvaluation.deleteComment.loadingStatus;
};

const getComments = ({ selfFaultEvaluation }) => {
	return selfFaultEvaluation.comments?.data || [];
};

const getShowUtcDates = ({ eventLog }) => {
	return eventLog.dateKind === dateKind.UTC;
};

const getUser = ({ overview }) => {
	return overview.user?.data;
};

const getSelectedCause = ({ selfFaultEvaluation }) => {
	return selfFaultEvaluation.selectedCause;
};

const getIsPreselectedCause = ({ selfFaultEvaluation }) => {
	return selfFaultEvaluation.isPreselectedCause;
};

const getCurrentEventId = ({ selfFaultEvaluation }) => {
	return selfFaultEvaluation.currentEventId;
};

const getSelfFaultEvaluationRawError = ({ selfFaultEvaluation }) => {
	const comments = selfFaultEvaluation.comments;
	const deleteComment = selfFaultEvaluation.deleteComment;
	const postComment = selfFaultEvaluation.postComment;

	if (comments?.loadingStatus === apiCallStatus.ERROR) {
		return { error: comments.error, errorCode: comments.error?.statusCode, loadingStatus: comments.loadingStatus };
	}
	if (deleteComment?.loadingStatus === apiCallStatus.ERROR && deleteComment?.error) {
		return { error: deleteComment.error, errorCode: deleteComment.error?.statusCode, loadingStatus: deleteComment.loadingStatus };
	}
	if (postComment?.loadingStatus === apiCallStatus.ERROR && postComment?.error) {
		return { error: postComment.error, errorCode: postComment.error?.statusCode, loadingStatus: postComment.loadingStatus };
	}
	return { loadingStatus: comments?.loadingStatus };
};

const getErrorData = createErrorDataSelector(getSelfFaultEvaluationRawError);

export const getModel = createSelector([
	getSelectedEvent,
	getEventLogs,
	getPostCommentStatus,
	getGetCommentsStatus,
	getComments,
	getShowUtcDates,
	getDeleteCommentStatus,
	getUser,
	getSelectedCause,
	getIsPreselectedCause,
	getCurrentEventId,
	getErrorData
], (
	selectedEvent,
	eventLogs,
	postCommentStatus,
	getCommentStatus,
	comments,
	showUtcDates,
	deleteCommentStatus,
	user,
	selectedCause,
	isPreselectedCause,
	currentEventId,
	errorData
) => {
	return {
		selectedEvent,
		eventLogs,
		postCommentStatus,
		getCommentStatus,
		comments,
		showUtcDates,
		deleteCommentStatus,
		user,
		selectedCause,
		isPreselectedCause,
		currentEventId,
		errorData
	};
});
